import { useCallback, useRef } from 'react';
// 将一些需要获取最新状态事件函数与状态隔离副作用触发开来,避免意外的副作用。比如请求 / window.addEventListener中回调函数。
// 参考 https://react.dev/learn/removing-effect-dependencies#removing-unnecessary-dependencies 和 https://github.com/facebook/react/blob/v19.1.1/packages/react-reconciler/src/ReactFiberHooks.js#L2927-L2942 封装
// 也可使用事件行为状态进行规避
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useEventCallback = <T extends (...args: any[]) => any>(
  callback: T,
): T => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  return useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ((...args: any[]) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-argument
      return callbackRef.current(...args);
    }) as T,
    [],
  );
};
export default useEventCallback;
